import { httpRequest } from "../../http.ts";
import { LaunchAdSerializer } from "../../../models/serializers/launchAdSerializer.ts";
import { LaunchAdStatus } from "@models/launchAd.ts";

export class CommandUpdateLaunchAdStatus {
  async run(launchAdId: number, status: LaunchAdStatus) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/launch-ads/${launchAdId}/`;
    const payload = { status };

    const result = await httpRequest<any | null>(url, {
      method: "PATCH",
      body: payload,
    });

    return new LaunchAdSerializer().deserialize(result);
  }
}
